import { useConnect } from '@lore/query-connect';

export default function createEvaluationsHook(model, entityKey, { completed = false } = {}) {
  return function useEvaluations({ network, state, schoolStart, schoolEnd } = {}) {
    return useConnect(`${model}.find`, {
      where: {
        eager: {
          $where: {
            ...(completed ? { completed: true } : {}),
            ...(state ? {
              [entityKey]: {
                $where: {
                  site: {
                    $where: {
                      state: {
                        $ilike: state
                      }
                    }
                  }
                }
              }
            } : {
              networkId: network?.id
            }),
            createdAt: {
              $lte: schoolEnd,
              $gte: schoolStart
            }
          }
        }
      },
      pagination: {
        pageSize: 1
      }
    });
  };
}
